module.exports = __webpack_public_path__ + "static/media/EmptyShared.54c3f421.svg";